import { FunctionComponent } from 'react'

import { Box, Button, ButtonProps, Icon, Text } from '@chakra-ui/react'

interface QuickActionButtonProps extends ButtonProps {
	text?: string
	icon?: FunctionComponent<React.SVGProps<SVGSVGElement>>
}

export const QuickActionButton = ({
	text,
	icon,
	children,
	...btnProps
}: QuickActionButtonProps) => {
	return (
		<Box
			w="100%"
			h="3rem"
			pos="relative"
		>
			<Button
				data-wwt-id="reason-popup__quick-action--button"
				variant="icon"
				size="md"
				w="100%"
				alignItems="center"
				justifyContent="flex-start"
				gap="1rem"
				cursor="pointer"
				bg="white"
				borderRadius="0"
				ps="1.25rem"
				pe="1.25rem"
				_hover={{ bg: 'gray.100' }}
				{...btnProps}
			>
				{icon && (
					<Icon
						as={icon}
						boxSize="1.5rem"
					/>
				)}
				{text && <Text textStyle="body-text-6">{text}</Text>}
			</Button>
			{children}
		</Box>
	)
}
